module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAANCAYAAACKCx+LAAAAVUlEQVQYlc3QsQmAQBBE0XeHgbVYnLYh2I5YiZmcdVymgQteYu4ks/CZgZ1UShG6whNkH/ovWL0/iHvLGFEbUDFlnJgbsOBIMUmPPaoH1K6Ne3aqcAN7rxOqPoZzAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/发布时间2.png
// module id = 0n8d
// module chunks = 1